module.exports = __webpack_public_path__ + "static/media/b-sci-major-20_LR.7bf8edb5.jpg";